export const startDownloadFileByLink = (fileLink: string) => {
  const link = document.createElement('a')
  link.href = fileLink
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const startDownloadFileByBlob = (blob: string) => {
  const link = document.createElement('a')
  link.target = '_blank'
  link.href = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
  link.click()
}
